import type {Logistic} from '~/types/legacy'
import type {Populated} from '~/types/populated'

export function useLogistics() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'logisticsGlobal',
      depth: 3,
      draft: !!route.query.preview,
    })

    return result as Populated<Logistic>
  }

  return {fetch}
}
